import styled from "@emotion/styled";

export const FixedRulerGridRoot = styled.div({
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 1000000,
    pointerEvents: "none",
});

export const RulerGridHorizontalLine = styled.div<{ offset: number; opacity: number }>(props => ({
    position: "absolute",
    top: props.offset * 8,
    left: 0,
    right: 0,
    height: 1,
    backgroundColor: `rgba(0, 0, 0, ${props.opacity})`,
}));

export const RulerGridVerticalLine = styled.div<{ offset: number; opacity: number }>(props => ({
    position: "absolute",
    top: 0,
    bottom: 0,
    left: props.offset * 8,
    width: 1,
    backgroundColor: `rgba(0, 0, 0, ${props.opacity})`,
}));
